import React from "react";

import Information1 from "../../../assets/image/1nformation1.png";
import Information2 from "../../../assets/image/1nformation2.png";
import Information3 from "../../../assets/image/1nformation3.png";

const featuresData = [
    {
        id: 1,
        title: "1000+ Successful Cases – A proven track record of helping clients navigate legal complexities.",
        image: Information1,
        alt: "Apply  Online",
        link: "/apply"  // internal route
    },
    {
        id: 2,
        title: "Nationwide Presence – Offices in major cities across Canada for convenient access.",
        image: Information2,
        alt: "Important Information",
        link: "/important-info"
    },
    {
        id: 3,
        title: "Strong Legal Network – Collaborations with top advocates to deliver the best results.",
        image: Information3,
        alt: "Immigration Resources",
        link: "/immigration-resources"
    },
];

const Unparalleled = () => {
    return (
        <section className="relative md:pt-[80px]">

            {/* TOP CARDS */}
            <div className="max-w-7xl mx-auto px-4 -mb-32 relative z-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">

                    {featuresData.map((item) => (
                        <div
                            key={item.id}
                            className="group bg-white shadow-lg overflow-hidden"
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={item.image}
                                    alt={item.alt}
                                    className="w-full h-48 sm:h-60 object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-500"></div>
                            </div>

                            <div className="p-6 text-center">
                                <h3 className="text-[26px] font-semibold text-gray-900">
                                    {item.title}
                                </h3>
                            </div>
                        </div>
                    ))}

                </div>
            </div>

            {/* BLUE SECTION */}
            <div className="bg-[#2f5b86] pt-40 md:pt-60 pb-20 md:pb-24 text-center text-white px-4">
                <h2 className="text-3xl md:text-5xl font-light mb-6">
                    Our Mission

                </h2>

                <div className="flex flex-col max-w-7xl mx-auto px-4  sm:flex-row items-center justify-center gap-4">

                    <div className="flex gap-2">
                        <div className="w-1 h-[2px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[2px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[2px] bg-[#ec4e4f]"></div>
                        <div className="w-12 h-[2px] bg-[#ec4e4f]"></div>
                    </div>
                    <p className="text-[24px] font-[400] text-center">
                        Our mission is to simplify legal proceedings by offering expert guidance, efficient case management, and
                        seamless coordination between clients and advocates, while upholding the highest standards of
                        professionalism and client satisfaction.


                    </p>
                    <div className="flex gap-2">
                        <div className="w-12 h-[2px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[2px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[2px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[2px] bg-[#ec4e4f]"></div>


                    </div>
                </div>
            </div>

        </section>
    );
};

export default Unparalleled;
